(function ($) {
    $.fn.contactFrom = function () {

        // Function to 
        const closeSelect = ($el) => {
            const $selectcontainer = $($el).closest('.wpcf7-select-container').first();
            $selectcontainer.removeClass('open'); 
        }

        // Function to 
        const closeAllSelect = () => {
            const $selectBoxes = $('.wpcf7-select');
            
            $selectBoxes.each((i, el) => {
                closeSelect(el);
            }); 
        }

        // Function to 
        const toggleSelect = ($el) => {
            const $selectcontainer = $($el).closest('.wpcf7-select-container').first();
            $selectcontainer.toggleClass('open'); 
        }

        // For contact form modal links
        $('.contact-form-modal-link').each((index, link) => {
            const $self = $(link);
            
            // Open modal on click
            $self.on('click', function(e) {
                let $formModal = $('#' + $self.attr('data-form-modal'));
                e.preventDefault();
                $.frModalOpen($formModal);
            });
        });

        this.each((index, element) => {
            const $self = $(element);
            const $selectBoxes = $self.find('.wpcf7-select');

            // Add container to all selects
            $selectBoxes.wrap('<div class="wpcf7-select-container"></div>');

            $selectBoxes.on('click', function (e) {
                toggleSelect(e.target);
            });

            $selectBoxes.on('change', function(e) {
                setTimeout(function(){
                    closeSelect(e.target);
                },0);
            });
            
        });

        $('body').on('click', function(e) {
            if(!$(e.target).is('select')) {
                closeAllSelect();
            }
        });


        return this;
    }

    $(() => {
        $('.wpcf7').contactFrom();
    })

})($);




// WEBPACK FOOTER //
// ./scripts/components/contact-form.js